export const DOMAIN_STATUSES = {
    VERIFIED: 'verified',
    UNVERIFIED: 'unverified',
    PENDING: 'pending',
};

export const DOMAIN_STATUS_COLOR = {
    [DOMAIN_STATUSES.VERIFIED]: 'var(--palette-green-80)',
    [DOMAIN_STATUSES.UNVERIFIED]: 'var(--palette-red-80)',
    [DOMAIN_STATUSES.PENDING]: 'var(--status-status-sorta-good)',
};

export const RECORD_STATUSES = {
    VERIFIED: 'VERIFIED',
    NOT_FOUND: 'NOT_FOUND',
    MISCONFIGURED: 'MISCONFIGURED',
};

export const RECORD_STATUSES_LABEL = {
    [RECORD_STATUSES.VERIFIED]: 'Verified',
    [RECORD_STATUSES.NOT_FOUND]: 'Not Found',
    [RECORD_STATUSES.MISCONFIGURED]: 'Misconfigured',
};
